import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '../api/auth';
import { ApiException } from '../api/client';
import { Alert } from '../components/Alert';
import { Button } from '../components/Button';
import { AccentCard } from '../components/Card';
import { Input } from '../components/Input';
import { AuthLayout } from '../components/Layout';

export function RegisterPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setLoading(true);
    try {
      const result = await authApi.register({ email: email.trim().toLowerCase() });
      setSuccess(result.message);
      setEmail('');
    } catch (err) {
      setError(err instanceof ApiException ? err.message : 'Terjadi kesalahan tak terduga.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <AccentCard title="Daftar Akun Booku Client" subtitle="Langkah 1 dari 3 — Input email">
        {success && (
          <div className="mb-4">
            <Alert variant="success" title="Email terkirim">
              {success}
              <div className="mt-2 text-xs">
                Cek inbox (atau folder Spam) untuk link verifikasi. Link berlaku 24 jam.
              </div>
            </Alert>
          </div>
        )}

        {error && (
          <div className="mb-4">
            <Alert variant="error">{error}</Alert>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            type="email"
            name="email"
            label="Email"
            placeholder="alamat@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
            disabled={loading}
            hint="Kami akan kirim link verifikasi ke email ini."
          />
          <Button type="submit" variant="primary" fullWidth loading={loading}>
            Kirim Link Verifikasi
          </Button>
        </form>

        <div className="mt-6 text-center text-sm text-gray-600">
          Sudah punya akun?{' '}
          <Link to="/login" className="text-booku-primary font-medium hover:underline">
            Login
          </Link>
        </div>
      </AccentCard>
    </AuthLayout>
  );
}
